<template>
  <!--
    	作者：luoyiming
    	时间：2020-04-26
    	描述：门店-编辑门店
    -->
  <div class="product-add">
    <el-form size="small" ref="dataForm" :model="form" label-width="120px" :rules="rules">
      <!--添加门店-->
      <div class="common-form">分类</div>

      <el-form-item label="分类名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入分类名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="卡片图片" prop="image_id">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.image_id != ''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="概率" width="80" prop="probability">
        <el-input type="number" v-model="form.probability" class="max-w460">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="分类排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入序号" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit('dataForm')" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import codeApi from '@/api/code.js';
import Upload from '@/components/file/Upload';
import { formatModel } from '@/utils/base.js';
export default {
  components: {
    /*腾讯地图拾取器*/
    Getpoint,
    Upload
  },
  data() {
    var probabilityValidator = (rule, value, callback) => {
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (value > 0 && value <= 100 && reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入大于零小于一百不超过二位小数的数字'));
      }
    };
    return {
      /*form表单数据*/
      form: {
        parent_id: null,
        category_id: null,
        name: '',
        sort: 0,
        image_id: '',
        probability: 0
      },
      category: [],
      /*查询信息*/
      list: [],
      /*是否上传图片*/
      isupload: false,
      loading: false,
      file_path: '',
      rules: {
        name: [{ required: true, message: '请填写分类名称', trigger: 'blur' }],
        image_id: [{ required: true, message: '请选择图片', trigger: ['change', 'blur'] }],
        probability: [{ required: true, message: '请填写概率', trigger: 'blur' },
        { required: true, validator: probabilityValidator, trigger: 'blur' }]
      }
    };
  },
  created() {
    this.form.parent_id = this.$route.query.parent_id;
    this.form.category_id = this.$route.query.category_id;

    this.getData();
  },

  methods: {
    /*修改*/
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let self = this;
          let form = self.form;
          self.loading = true;
          codeApi.cateEdit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.$router.push('/card/category/zifenlei/index?parent_id=' + self.form.parent_id);
            }).catch(error => {
              self.loading = false;
            });
        } else {
          this.$message.error('请完善必填信息');
          return false;
        }
      });
    },

    /*获取参数*/
    getData() {
      let self = this;
      codeApi.cardType({
        category_id: self.form.category_id
      }, true)
        .then(res => {
          self.file_path = res.data.list[0].save_name;
          self.form.image_id = res.data.list[0].image_id;
          self.form.name = res.data.list[0].name;
          self.form.sort = res.data.list[0].sort;
          self.form.probability = res.data.list[0].probability;
        })
        .catch(error => {

        });

    },

    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        this.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },



    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }

};
</script>

<style lang="scss" scoped>
.basic-setting-content {}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/card/category/zifenlei/edit.vue